/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perks_Trigger_Role_AnyInputs */



/**
* | output |
* | --- |
* | "Holding a role" |
*
* @param {Perks_Trigger_Role_AnyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_trigger_role_any = /** @type {((inputs?: Perks_Trigger_Role_AnyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Trigger_Role_AnyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("С ролью")
	return /** @type {LocalizedString} */ ("Holding a role")
});